import React from 'react';
import { Skeleton } from '@fourthwall/components';
import { formatSubscriptionBytes } from '@modules/Dashboard/modules/Subscriptions';
import * as S from './StorageLimit.styled';
export const StorageLimit = ({ title, currentSize, maxSize, isLoading }) => {
    const completionPercentage = (currentSize / maxSize) * 100;
    const isUnlimited = maxSize === -1;
    const isFull = isUnlimited ? false : currentSize >= maxSize;
    if (isLoading)
        return React.createElement(StorageLimitSkeleton, null);
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement(S.Title, null, title),
            React.createElement(S.Limit, { isFull: isFull },
                formatSubscriptionBytes(currentSize),
                !isUnlimited && ` of ${formatSubscriptionBytes(maxSize)} used`)),
        !isUnlimited && React.createElement(S.Bar, { isFull: isFull, completionPercentage: completionPercentage })));
};
export const StorageLimitSkeleton = () => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement(Skeleton.Shape, { width: 170, height: 24 }),
            React.createElement(S.Limit, null,
                React.createElement(Skeleton.Shape, { width: 170, height: 24 }))),
        React.createElement(Skeleton.Shape, { width: "100%", height: 10 })));
};
StorageLimit.Skeleton = StorageLimitSkeleton;
